import React from 'react';
import { connect } from 'react-redux';

import Icon from '@components/icon/Icon.tsx';
import Link from '@components/link/Link.tsx';
import { s } from '@functions/seo.ts';
import { StoreT } from '@global/types.ts';

import checkChange from './methods/checkChange.ts';
import checkSmallMenu from './methods/checkSmallMenu.ts';
import getNav from './methods/getNav.ts';
import init from './methods/init.ts';
import pageScroll from './methods/pageScroll.ts';
import setMenuState from './methods/setMenuState.ts';

import MenuI from './types.ts';

import renderActions from './renders/renderActions.tsx';
import renderExecutorsBlock from './renders/renderExecutorsBlock.tsx';
import renderNav from './renders/renderNav.tsx';

class Menu extends React.Component<MenuI['props'], MenuI['state']> implements MenuI {
    parent: MenuI['parent'];

    constructor(props: MenuI['props']) {
        super(props);
        this.state = {};

        this.pageScroll = this.pageScroll.bind(this);

        this.parent = React.createRef();
    }

    getNav = getNav;
    checkSmallMenu = checkSmallMenu;
    pageScroll = pageScroll;
    setMenuState = setMenuState;
    checkChange = checkChange;

    renderNav = renderNav;
    renderActions = renderActions;

    renderExecutorsBlock = renderExecutorsBlock;

    init = init;

    componentDidMount() {
        const { isFooter } = this.props;

        if (!isFooter) {
            setTimeout(() => {
                this.checkChange();
            }, 100);
        }
    }

    componentDidUpdate() {
        setTimeout(() => {
            this.checkChange();
        }, 100);
    }

    render() {
        const { isScrollActive } = this.state;
        const { isFooter, device, handlerMenu, user, designMode } = this.props;

        return (
            <div
                ref={this.parent}
                className={`publicTop ${isFooter ? '_footer' : ''} ${
                    isScrollActive ? '_scrollActive' : ''
                }`}
            >
                {isFooter && <>{this.renderExecutorsBlock()}</>}
                <div className="publicTop__inner _row _main">
                    <div className="publicTop__logo">
                        <Link
                            className="publicTop__logoLink"
                            pageName={user ? 'corporation' : 'auth'}
                        >
                            {!s() && (
                                <img
                                    src={require(
                                        `@img/crm/${isFooter ? 'logo-white.svg' : designMode === 'newYear' ? 'newYear/logo.svg' : 'logo.svg'}`,
                                    )}
                                    alt=""
                                    className="publicTop__logoIcon"
                                />
                            )}
                        </Link>
                    </div>

                    {this.renderNav()}
                    {this.renderActions()}

                    {device === 'mobile' && !isFooter && (
                        <div
                            className="publicTop__menu"
                            onClick={() => {
                                if (handlerMenu) {
                                    handlerMenu(true);
                                }
                            }}
                        >
                            <Icon name="public-menu" />
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

function mapStateToProps(state: StoreT<'crm'>) {
    return {
        storePages: state.pages,
        device: state.device,
        user: state.user,
        levels: state.levels,
        designMode: state.designMode,
    };
}

export default connect(mapStateToProps)(Menu);
